/**
 * 앱 스토어 링크 + 기기별 다운로드 분기.
 * - 모바일: 그 기기 OS에 맞는 스토어로 직행
 * - PC: QR 코드(`/dl` 스마트 링크)를 보여주고 폰으로 스캔 유도
 */

// 1등급 앱 (com.hongcomms.grade)
export const APP_STORE_URL = 'https://apps.apple.com/kr/app/id6774458884';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.hongcomms.grade';

/**
 * 현재 기기 OS에 맞는 스토어 URL. iOS / Android 가 아니면(PC 등) null.
 */
export function mobileStoreUrl() {
  if (typeof navigator === 'undefined') return null;
  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/i.test(ua)) return APP_STORE_URL;
  if (/Android/i.test(ua)) return PLAY_STORE_URL;
  return null;
}

/**
 * QR 코드가 가리킬 스마트 다운로드 링크.
 * 폰으로 스캔해 열면 `/dl` 페이지가 OS를 보고 알맞은 스토어로 보냄.
 * origin 을 그대로 써서 로컬/배포 환경 모두 동작.
 */
export function downloadSmartUrl() {
  if (typeof window === 'undefined') return PLAY_STORE_URL;
  return `${window.location.origin}/dl`;
}
